import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CaretLeft = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.5 16.25L6.25 10L12.5 3.75", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

export { CaretLeft as default };
//# sourceMappingURL=CaretLeft.js.map
